import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
  Textarea,
  Tooltip,
  useClipboard,
  useColorModeValue,
  VStack,
  Text,

} from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import { BsGithub, BsLinkedin, BsPerson, BsTwitter, BsFillTelephoneFill } from 'react-icons/bs';
import { MdEmail, MdOutlineEmail } from 'react-icons/md';
import styled from 'styled-components';
import { ColorContext } from '../Context/ColorContext';
import Aos from "aos"
import "aos/dist/aos.css"




export default function Contact() {
  const { hasCopied, onCopy } = useClipboard('bharat092486@gmail.com');
  const { colors, setColors, underLineColor, textColor, family } = useContext(ColorContext)



  useEffect(() => {
    Aos.init({ duration: 1000 })
  }, [])




  return (
    <Box>

      <Heading color='black' fontSize={['1.5rem', '1.9rem', '2.6rem', '3.2rem']} textAlign={"center"} marginBottom={"4%"} id="contact">Contact</Heading>
      <Flex flexDirection={"column"} gap={"20px"}>
        <Button className='check'  onClick={() => window.open('https://github.com/bharat24862486', '_blank')} id="contact-github" leftIcon={<BsGithub />} border={`2px solid ${colors}`} _hover={{ background: colors, color: 'white' }} backgroundColor={"white"} w={["70%", "60%", "50%", "40%"]} display={"block"} margin={"auto"}>Bharat</Button>
        <Button className='check'  onClick={() => window.open('https://www.linkedin.com/in/bharatsharma2486', '_blank')} id="contact-linkedin" leftIcon={<BsLinkedin />} border={`2px solid ${colors}`} _hover={{ background: colors, color: 'white' }} backgroundColor={"white"} w={["70%", "60%", "50%", "40%"]} display={"block"} margin={"auto"}>Bharat</Button>
        <Button className='check'  id="contact-phone"  leftIcon={<BsFillTelephoneFill />} border={`2px solid ${colors}`} _hover={{ background: colors, color: 'white' }} backgroundColor={"white"} w={["70%", "60%", "50%", "40%"]} display={"block"} margin={"auto"}>9319764920</Button>
        <Button className='check'  id="contact-email" leftIcon={<MdEmail />} border={`2px solid ${colors}`} _hover={{ background: colors, color: 'white' }} backgroundColor={"white"} w={["70%", "60%", "50%", "40%"]} display={"block"} margin={"auto"}>bharat092486@gmail.com</Button>

      </Flex>
    </Box>
    // <Flex
    //   bg={useColorModeValue('gray.100', 'gray.900')}
    //   align="center"
    //   justify="center"
    //   css={{
    //     backgroundImage: useColorModeValue(CONFETTI_LIGHT, CONFETTI_DARK),
    //     backgroundAttachment: 'fixed',
    //   }}
    //   id="contact">
    //   <Box
    //     borderRadius="lg"
    //     m={{ base: 5, md: 16, lg: 10 }}
    //     p={{ base: 5, lg: 16 }}>
    //     <Box>
    //       <VStack spacing={{ base: 4, md: 8, lg: 20 }}>
    //         <Heading
    //           fontSize={{
    //             base: '4xl',
    //             md: '5xl',
    //           }}>
    //           Get in Touch
    //         </Heading>

    //         <Stack
    //           spacing={{ base: 4, md: 8, lg: 20 }}
    //           direction={{ base: 'column', md: 'row' }}>
    //           <Stack
    //             align="center"
    //             justify="space-around"
    //             direction={{ base: 'row', md: 'column' }}>
    //             <Tooltip
    //               label={hasCopied ? 'Email Copied!' : 'Copy Email'}
    //               closeOnClick={false}
    //               hasArrow>
    //               <IconButton
    //                 aria-label="email"
    //                 variant="ghost"
    //                 size="lg"
    //                 fontSize="3xl"
    //                 icon={<MdEmail />}
    //                 id="contact-email"
    //                 _hover={{
    //                   bg: 'blue.500',
    //                   color: useColorModeValue('white', 'gray.700'),
    //                 }}
    //                 onClick={onCopy}
    //                 isRound
    //               />
    //             </Tooltip>

    //             <Link href="https://github.com/bharat24862486">
    //               <IconButton
    //                 aria-label="github"
    //                 variant="ghost"
    //                 size="lg"
    //                 fontSize="3xl"
    //                 icon={<BsGithub />}
    //                 id="contact-github"

    //                 _hover={{
    //                   bg: 'blue.500',
    //                   color: useColorModeValue('white', 'gray.700'),
    //                 }}
    //                 isRound
    //               />
    //             </Link>

    //             <Link href="9319764920">
    //               <IconButton
    //                 aria-label="twitter"
    //                 variant="ghost"
    //                 size="lg"
    //                 icon={<BsFillTelephoneFill size="28px" />}
    //                 id="contact-phone"
    //                 _hover={{
    //                   bg: 'blue.500',
    //                   color: useColorModeValue('white', 'gray.700'),
    //                 }}
    //                 isRound
    //               />
    //             </Link>

    //             <Link href="https://www.linkedin.com/in/bharatsharma2486/">
    //               <IconButton
    //                 aria-label="linkedin"
    //                 variant="ghost"
    //                 size="lg"
    //                 icon={<BsLinkedin size="28px" />}
    //                 id="contact-linkedin"
    //                 _hover={{
    //                   bg: 'blue.500',
    //                   color: useColorModeValue('white', 'gray.700'),
    //                 }}
    //                 isRound
    //               />
    //             </Link>
    //           </Stack>

    //           <Box
    //             bg={useColorModeValue('white', 'gray.700')}
    //             borderRadius="lg"
    //             p={8}
    //             color={useColorModeValue('gray.700', 'whiteAlpha.900')}
    //             shadow="base">
    //             <VStack spacing={5}>
    //               <FormControl isRequired>
    //                 <FormLabel>Name</FormLabel>

    //                 <InputGroup>
    //                   <InputLeftElement children={<BsPerson />} />
    //                   <Input type="text" name="name" placeholder="Your Name" />
    //                 </InputGroup>
    //               </FormControl>

    //               <FormControl isRequired>
    //                 <FormLabel>Email</FormLabel>

    //                 <InputGroup>
    //                   <InputLeftElement children={<MdOutlineEmail />} />
    //                   <Input
    //                     type="email"
    //                     name="email"
    //                     placeholder="Your Email"
    //                   />
    //                 </InputGroup>
    //               </FormControl>

    //               <FormControl isRequired>
    //                 <FormLabel>Message</FormLabel>

    //                 <Textarea
    //                   name="message"
    //                   placeholder="Your Message"
    //                   rows={6}
    //                   resize="none"
    //                 />
    //               </FormControl>

    //               <Button
    //                 colorScheme="blue"
    //                 bg="blue.400"
    //                 color="white"
    //                 _hover={{
    //                   bg: 'blue.500',
    //                 }}
    //                 isFullWidth>
    //                 Send Message
    //               </Button>
    //             </VStack>
    //           </Box>
    //         </Stack>
    //       </VStack>
    //     </Box>
    //   </Box>
    // </Flex>
  );
}


